/**
 * Returns the default print scale for the passed layer
 */

function getDefaultScale(layer) {
    let v = '0';
    switch(layer){
        case "osvml":
        case "os10k":
          v = '10000';
        break;
        case "os25k":
          v = '25000';
        break;
        case "os50k":
          v = '50000';
        break;
        case "os250k":
          v = '250000';
        break;
        case "aerial":
        case "osmmbw":
        case "osmm":
        default:
          v = '1250';
        break;
    }
    return v;
}

export default getDefaultScale;